import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import Session from 'components/Session';
import { logPageView, initGA } from 'utils/analytics';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import ValidateCoach from 'components/ValidateCoach';
import { selector } from './redux';
import getCoachFromDatabase from './actions';

class VerifyCoach extends Component {
  // static propTypes = {
  //   logoutUser: PropTypes.func.isRequired,
  // };

  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line
  }

  render() {
    return (
      <div>
        <ValidateCoach {...this.props} />
      </div>
    );
  }
}

export default connect(selector,
    { getCoachFromDatabase })(Session(VerifyCoach));




// WEBPACK FOOTER //
// ./src/containers/VerifyCoach/VerifyCoach.js